<template
  ><div>
    <div class="form-wrapper">
      <VForm
        :name="name"
        :initialValues="initialValues"
        :fields="fields"
      ></VForm>
    </div>
    <div class="btn-wrapper">
      <VButton
        label="Complete"
        :disabled="!_isFormValid || isLoading"
        @click="onBtnClick()"
      ></VButton>
    </div></div
></template>

<script>
import Vue from "vue";
import VueTypes from "vue-types";
import { mapActions, mapGetters } from "vuex";

import VForm from "@/components/VForm";
import { billingAddressFormFields } from "@/constants/forms";
import { convertBillingInfoToApiFormat } from "@/utils/util";
import VButton from "@/components/VButton";
import VElementsAddingModal from "@/components/VElementsAddingModal";

//mixins
import withFormUtils from "@/mixins/withFormUtils";
import withToasted from "@/mixins/withToasted";
import withNavigate from "@/mixins/withNavigate";
import { convertDataToApi } from "../utils/util";

export default Vue.component("SingUpBillingForm", {
  components: {
    VForm,
    VButton,
    VElementsAddingModal
  },

  data() {
    return {
      name: "signUpBilling",
      isModalOpen: false,
      initialValues: {}
    };
  },

  mixins: [withFormUtils, withToasted, withNavigate],

  computed: {
    fields() {
      return [
        ...billingAddressFormFields.map(item => {
          item.layout = "full";
          return item;
        })
      ];
    },

    _isFormValid() {
      return this.isFormValid(this.name);
    },

    ...mapGetters("account", ["isLoading", "identity"])
  },

  methods: {
    onBtnClick() {
      this.validateForm(this.name);
      if (this._isFormValid) {
        return this.updateAccount({
          patch: true,
          id: this.id,
          values: convertBillingInfoToApiFormat(this.formValues),
          cb: () => {
            this.fetchIdentity({
              onSuccess: () => {
                localStorage.setItem(
                  this.name,
                  JSON.stringify(this.formValues)
                );
                localStorage.clear();
                this.navigate("/payment");
              }
            });
          },
          onError: () =>
            this.errorToast("Form is valid but account cant be updated")
        });
      }
    },

    ...mapActions("account", ["updateAccount", "fetchIdentity"])
  },

  created() {
    const { account, user } = this.identity;

    this.id = account.id;

    const { email } = user;

    const {
      name,
      address_city,
      address_country,
      address_street,
      address_unit,
      address_state,
      address_zip
    } = account;

    if (account) {
      this.initialValues = {
        address_city,
        address_country,
        address_line_1: address_street,
        address_line_2: address_unit,
        address_state,
        address_zip,
        billing_email: email,
        billing_address: name
      };

      if (!this.initialValues.country) {
        this.initialValues.country = "US";
      }
    }
  }
});
</script>

<style lang="scss" scoped></style>
